// extracted by mini-css-extract-plugin
module.exports = {"lineItem":"LineItem_lineItem__1ErjS","labelText":"LineItem_labelText__bLzMD","contentText":"LineItem_contentText__4N6Pi"};